import { BaseNavigationCallback, BaseStep } from '@lx/quote-tool/lite/shared/types';
import { NavigationBarItem } from './navigation-bar-item.type';
import { RouteIds } from './route-ids.enum';
import { GoogleAnalyticsEventEnum } from '../google-analytics';
import { Type } from '@angular/core';

/**
 * App-specific navigation callback that returns RouteIds.
 * Specializes the base navigation callback type for Quote Tool Lite.
 */
export type NavigationCallback = BaseNavigationCallback<RouteIds>;

/**
 * App-specific Step interface for Quote Tool Lite.
 * Extends the base Step type with app-specific navigation and analytics properties.
 */
export interface Step extends Omit<BaseStep<RouteIds>, 'googleAnalyticsEvent'> {
  /**
   * Navigation bar items to display (app-specific type)
   */
  navigationBarItems?: NavigationBarItem[];

  /**
   * Optional floating panel configuration
   */
  floatingPanel?: FloatingPanel;

  /**
   * Google Analytics event enum for the step (app-specific type)
   */
  googleAnalyticsEvent?: GoogleAnalyticsEventEnum;
}

/**
 * Floating panel configuration.
 * Re-exported from base types for convenience.
 */
export interface FloatingPanel {
  /**
   * The component to display in the floating panel
   */
  component: Type<unknown>;

  /**
   * Position of the floating panel
   * - title: Placed at the same level as the step title
   * - content: Placed at the same level as the step content
   */
  position: 'title' | 'content';

  /**
   * Whether the panel is enabled on mobile devices
   * @default false
   */
  enabledMobile?: boolean;

  /**
   * Position of the panel on mobile devices
   */
  mobilePosition?: 'top' | 'bottom';
}
